exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".flow-layout{display:flex;flex:1;align-items:center}.flow-layout.is-vertical{flex-direction:column}.flow-layout.is-truncated{overflow:hidden}.flow-layout.is-center{justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /usr/src/sentry/node_modules/css-loader?{"minimize":true}!/usr/src/sentry/node_modules/less-loader/dist/cjs.js!./less/components/flowLayout.less
// module id = 1016
// module chunks = 74